"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFirstError = exports.handleSlrConfigurationWeb = exports.showViber = exports.slrScenario = exports.clearLoggedInCookies = exports.setTicketCookies = exports.setMemberCookies = exports.routeTo = void 0;
const constants_1 = require("../../constants");
const helpers_1 = require("../../helpers");
const auth_1 = __importDefault(require("../../auth"));
const localStorageMember_1 = require("./localStorageMember");
const slrConfiguration_1 = require("../apisWithoutCache/slr/slrConfiguration");
const routeTo = (path) => {
    window.location.href = path;
};
exports.routeTo = routeTo;
const setMemberCookies = (member) => {
    (0, localStorageMember_1.setLocalStorageAuthUser)({
        authToken: "",
        userInfo: (0, localStorageMember_1.minimizeUserInfoFields)(member),
    });
};
exports.setMemberCookies = setMemberCookies;
const setTicketCookies = (ticket) => {
    const userTicket = String(ticket[1]).replaceAll(/"/g, "");
    (0, localStorageMember_1.setLocalStorageAuthUser)({
        authToken: "",
        tgtTicket: userTicket,
        tgtTimestamp: ticket[0],
    });
    auth_1.default.getInstance().auth.t = ticket[0];
    auth_1.default.getInstance().auth.k = userTicket;
};
exports.setTicketCookies = setTicketCookies;
const slrScenario = {
    ACTION_FORGET_PASSWORD: constants_1.ScreenConstants.NEW_PASSWORD,
    ACTION_LOGIN: [
        constants_1.ScreenConstants.REGISTER_NEW_USER,
        constants_1.ScreenConstants.LOGIN_SUCCESS,
    ],
    ACTION_REGISTRATION: constants_1.ScreenConstants.REGISTER_NEW_USER,
};
exports.slrScenario = slrScenario;
/**
 * show Viber
 */
const showViber = (country) => {
    return ["ly", "iq", "kw"].indexOf(country) > -1;
};
exports.showViber = showViber;
/**
 * Configuration web
 */
const handleSlrConfigurationWeb = (setslrConfiguration) => {
    (0, slrConfiguration_1.ssoConfigurations)()
        .then((response) => setslrConfiguration(response))
        .catch((error) => console.log(error));
};
exports.handleSlrConfigurationWeb = handleSlrConfigurationWeb;
/**
 * Delete LoggedIn Cookies
 */
const clearLoggedInCookies = () => {
    (0, helpers_1.destroyCookie)(constants_1.CookiesConstants.USER_INFO);
};
exports.clearLoggedInCookies = clearLoggedInCookies;
const getFirstError = (error) => {
    return error[Object.keys(error)[0]];
};
exports.getFirstError = getFirstError;
